// Google tag for Google Ads (AW-18544524284) and the Google Tag Manager
// container (GTM-NPKWD9JQ). Same policy as
// linkedin-insight.js: production ad hosts only, never internal devices, and
// only after the visitor accepts the marketing category in the cookie banner.
// Google's snippet is two inline <script>s; the site CSP forbids inline
// scripts, so the same setup runs here instead.

import { hasConsent, onConsentChange } from '../scripts/consent.js';
import { isInternalDevice } from './posthog.js';

const TAG_ID = 'AW-18544524284';
const GTM_ID = 'GTM-NPKWD9JQ';
const AD_HOSTS = ['scopeworth.app', 'www.scopeworth.app', 'getscopeworth.com', 'www.getscopeworth.com'];

let loaded = false;

function loadGoogleTag() {
  if (loaded || isInternalDevice() || !hasConsent('marketing')) return;
  if (!AD_HOSTS.includes(window.location.hostname)) return;
  loaded = true;

  window.dataLayer = window.dataLayer || [];
  // gtag.js reads the Arguments object, not an array: keep `arguments`.
  window.gtag = window.gtag || function gtag() { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', TAG_ID);

  addScript(`https://www.googletagmanager.com/gtag/js?id=${TAG_ID}`);
  // Tags configured in the container load from their own hosts, which the
  // CSP in public/_headers must list first or the browser blocks them.
  window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
  addScript(`https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`);
}

function addScript(src) {
  const s = document.createElement('script');
  s.async = true;
  s.src = src;
  document.head.appendChild(s);
}

loadGoogleTag();

// Accepting later loads the tag without a reload; the banner reloads on withdrawal.
onConsentChange((consent) => {
  if (consent.marketing) loadGoogleTag();
});
